import { render, staticRenderFns } from "./FacebookIconWhite.vue?vue&type=template&id=363dea50&scoped=true"
import script from "./FacebookIconWhite.vue?vue&type=script&lang=ts"
export * from "./FacebookIconWhite.vue?vue&type=script&lang=ts"
import style0 from "./FacebookIconWhite.vue?vue&type=style&index=0&id=363dea50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363dea50",
  null
  
)

export default component.exports